export default __webpack_public_path__ + "static/media/maskot.35c3f345.svg";